import { Video } from "components/UI/Video";
import { usePortableVideo } from "./hooks";

export const PortableVideo = () => {
  const { videoRef, videoAttributes } = usePortableVideo();

  return (
    <div style={{ display: "none" }}>
      <Video videoRef={videoRef} {...videoAttributes} />
    </div>
  );
};
